import { DEFAULT_PRODUCT_TYPE } from "~/components/products-layout/components/products-filters/components/filter/components/shop-filter/helpers/shop-filter.const";
import { AppliedFilters } from "~/components/products-layout/components/products-filters/types";
import { ProductRequestType } from "~/types/products-request-handler";

export const encodeFiltersHash = (
  sortParam?: string,
  filters?: AppliedFilters,
  isShop?: boolean | null,
  productType?: ProductRequestType,
): string => {
  if (
    !isShop &&
    !sortParam &&
    !productType &&
    (!filters || Object.keys(filters).length === 0)
  ) {
    return "";
  }

  const onlyTruthyFilters: AppliedFilters = filters
    ? Object.fromEntries(Object.entries(filters).filter(([, v]) => !!v))
    : null;

  const hashObject: { [key: string]: string } = {};

  if (sortParam) {
    hashObject.sorting = JSON.stringify(sortParam);
  }

  if (onlyTruthyFilters && Object.keys(onlyTruthyFilters).length > 0) {
    hashObject.filters = JSON.stringify(onlyTruthyFilters);
  }

  if (productType && productType !== DEFAULT_PRODUCT_TYPE) {
    hashObject.productType = JSON.stringify(productType);
  }

  if (isShop) {
    hashObject.isShop = JSON.stringify(isShop);
  }

  return `#${new URLSearchParams(hashObject).toString()}`;
};
